import React, { useState } from 'react';

export const useUploadFile = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);


  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFile(event.target.files ? event.target.files[0] : null);
  };

  const convertToBase64 = async (file: File) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onerror = (error) => {
        reject(error);
      };

      reader.onloadend = () => {
        if (typeof reader.result === 'string') {
          const base64Content = reader.result as string;
          resolve(base64Content.replace(
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
            '',
          ));
        }
      };
    });
  };

  const clearState = () => {
    setSelectedFile(null);
  };


  return {
    file: selectedFile,
    clearState,
    convertToBase64,
    handleFileChange,
  };
};
